import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { Address } from "../domain/Address";
import { HttpAddressRepository } from "../application/Address";
import { useUser } from "@/backend/user";

const repository = new HttpAddressRepository();

export function useAddress() {
  const { user } = useUser();
  const userId = user?.id as string;
  const queryClient = useQueryClient();

  // GET: Lista de direcciones del usuario
  const {
    data: addresses,
    isLoading,
    error,
  } = useQuery<Address[]>({
    queryKey: ["addresses", userId],
    queryFn: () => repository.getAddress(),
    enabled: !!userId, // solo ejecuta si hay userId
  });

  // POST: Crear dirección
  const createAddress = useMutation({
    mutationFn: (address: Address) => repository.createAddress(userId, address),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["addresses", userId] });
    },
  });

  // PUT: Actualizar dirección
  const updateAddress = useMutation({
    mutationFn: ({
      addressId,
      address,
    }: {
      addressId: string;
      address: Address;
    }) => repository.updateAddress(addressId, address),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["addresses", userId] });
    },
  });

  // DELETE: Eliminar dirección
  const deleteAddress = useMutation({
    mutationFn: (addressId: string) => repository.deleteAddress(addressId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["addresses", userId] });
    },
  });

  return {
    addresses,
    isLoading,
    error,
    createAddress,
    updateAddress,
    deleteAddress,
  };
}
